import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import * as React from 'react';
export const TimedRender = ({ showAfterMs: showAfter, hideAfterMs: hideAfter, onShow, onHide, retainIf, children })=>{
    const [show, setShow] = useState(!showAfter);
    useEffect(()=>{
        const id1 = showAfter ? setTimeout(()=>{
            setShow(true);
            onShow === null || onShow === void 0 ? void 0 : onShow();
        }, showAfter) : -1;
        const id2 = hideAfter ? setTimeout(()=>{
            const shouldHide = retainIf ? !retainIf() : true;
            if (shouldHide) {
                setShow(false);
                onHide === null || onHide === void 0 ? void 0 : onHide();
            }
        }, hideAfter) : -1;
        return ()=>{
            clearTimeout(id1);
            clearTimeout(id2);
        };
    }, [
        showAfter,
        hideAfter,
        retainIf,
        onShow,
        onHide
    ]);
    return show ? /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    }) : null;
};
